import { render, staticRenderFns } from "./AccionesDocumento.vue?vue&type=template&id=5ea18336&scoped=true"
import script from "./AccionesDocumento.vue?vue&type=script&lang=js"
export * from "./AccionesDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea18336",
  null
  
)

export default component.exports